// extracted by mini-css-extract-plugin
export var askAiIcon = "_kt-9";
export var container = "_kt-0";
export var groupSeparator = "_kt-a";
export var highlight = "_kt-4";
export var resultIcon = "_kt-5";
export var resultItem = "_kt-7";
export var resultSubtitle = "_kt-3";
export var resultTitle = "_kt-2";
export var resultsList = "_kt-1";
export var searchGroup = "_kt-6";
export var selected = "_kt-8";